/** Known 1×1 PNG placeholder saved instead of a real student signature. */
const REGISTRATION_SIGNATURE_PLACEHOLDER_SNIPPET =
  'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJ'

/** Real drawn signatures are much larger than placeholder blobs (~238 chars). */
const MIN_VALID_REGISTRATION_SIGNATURE_LENGTH = 500

/** True when registration.signature is a real student signature, not empty or a placeholder. */
export function hasValidRegistrationSignature(signature) {
  if (signature == null) return false
  const trimmed = String(signature).trim()
  if (!trimmed) return false
  if (trimmed.includes(REGISTRATION_SIGNATURE_PLACEHOLDER_SNIPPET)) return false
  if (trimmed.length < MIN_VALID_REGISTRATION_SIGNATURE_LENGTH) return false
  return true
}
